import React from 'react';
import { Box, Container, useMediaQuery, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { BottomNav } from './BottomNav';

/**
 * Main layout wrapper component
 */
export const MainLayout: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: 'background.default',
      }}
    >
      <Navbar />
      <Container
        component="main"
        maxWidth="xl"
        sx={{
          flexGrow: 1,
          pt: { xs: 2, sm: 3, md: 4 },
          px: { xs: 2, sm: 3 },
          pb: isMobile ? 12 : { sm: 3, md: 4 },
        }}
      >
        <Outlet />
      </Container>
      <BottomNav />
    </Box>
  );
};
